import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {FormControl, FormGroup} from '@angular/forms';

@Component({
  selector: 'app-documento',
  templateUrl: './documento.component.html',
  styleUrls: ['./documento.component.css']
})
export class DocumentoComponent implements OnInit, OnDestroy {

  @Input() formulario: FormGroup;
  @Input() rgcpf: string
  protected mascaraDocumento = ' ';

  constructor() {
  }

  ngOnInit() {
    this.formulario.addControl('rgcpf', new FormControl(this.rgcpf ? this.rgcpf : ''));
    if(this.rgcpf) {
      this.aplicarMascaraDocumento(this.rgcpf, true);
    }
  }

  ngOnDestroy(): void {
    this.formulario.removeControl('rgcpf');
  }

  protected aplicarMascaraDocumento(documento: string, edicao: boolean = false) {
    let mascaraRG = '0.000.0000000';
    if (edicao) {
      mascaraRG = '0.000.000';
    }
    const mascaraCPF = '000.000.000-00';
    const mascaraSemDocumentoEspecifico = '0000000000000';
    const indiceInicialValidoParaRG = 6;
    const indiceFinalValidoParaRG = 10;
    const indiceInicialValidoParaCPF = 9;
    const indiceFinalValidoParaCPF = 15;

    if (documento.length > indiceInicialValidoParaRG && documento.length < indiceFinalValidoParaRG) {
      this.mascaraDocumento = mascaraRG;
    } else if (documento.length > indiceInicialValidoParaCPF && documento.length < indiceFinalValidoParaCPF) {
      this.mascaraDocumento = mascaraCPF;
    } else {
      this.mascaraDocumento = mascaraSemDocumentoEspecifico;
    }

  }

  ajustarMascaraNoBlur(documento: string) {
    const tamanhoDocumento = documento.length;

    if (tamanhoDocumento === 9) {
      this.mascaraDocumento = '0.000.000';
    } else if (tamanhoDocumento > 9 && tamanhoDocumento <= 12) {
      this.mascaraDocumento = '0.000.0000-0000';
    } else if (tamanhoDocumento === 14) {
      this.mascaraDocumento = '000.000.000-00';
    } else {
      this.mascaraDocumento = '0000000000000';
    }
  }
}
